import { FC } from 'react';
import { cn } from '@/shared/lib';

type Props = {
  /** Опорные точки ленты, посчитанные диаграммой */
  sourceX: number;
  sourceY: number;
  sourceControlX: number;
  targetX: number;
  targetY: number;
  targetControlX: number;
  linkWidth: number;
  /** Класс цвета по знаку влияния перехода */
  colorClass: string;
  /** Изоляция другого понятия: лента показана приглушённо */
  isDimmed: boolean;
  isHovered: boolean;
  /** Подсказка ленты: понятия перехода, число диалогов и влияние */
  tooltip: string;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
};

/**
 * Лента перехода: толщина — число диалогов, цвет — знак влияния на целевой исход.
 * Приглушается при изоляции другого понятия и подсвечивается под курсором.
 */
export const SankeyLinkShape: FC<Props> = ({
  sourceX,
  sourceY,
  sourceControlX,
  targetX,
  targetY,
  targetControlX,
  linkWidth,
  colorClass,
  isDimmed,
  isHovered,
  tooltip,
  onMouseEnter,
  onMouseLeave,
  onClick,
}) => {
  const halfWidth = linkWidth / 2;
  const path = [
    `M ${sourceX} ${sourceY + halfWidth}`,
    `C ${sourceControlX} ${sourceY + halfWidth}, ${targetControlX} ${targetY + halfWidth}, ${targetX} ${targetY + halfWidth}`,
    `L ${targetX} ${targetY - halfWidth}`,
    `C ${targetControlX} ${targetY - halfWidth}, ${sourceControlX} ${sourceY - halfWidth}, ${sourceX} ${sourceY - halfWidth}`,
    'Z',
  ].join(' ');

  return (
    <path
      d={path}
      fill="currentColor"
      className={cn(colorClass, 'cursor-pointer')}
      fillOpacity={isDimmed ? 0.06 : isHovered ? 0.7 : 0.4}
      role="button"
      tabIndex={-1}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      <title>{tooltip}</title>
    </path>
  );
};
